import { Pipe, PipeTransform } from '@angular/core';
import { IPDFMatching } from '../bulk-upload-pdf-files-step.component';
import { MatchPotentialItemPipe } from './match-potential-item.pipe';

@Pipe({
  name: 'categoryFromPdf',
  standalone: true
})
export class CategoryFromPdfPipe extends MatchPotentialItemPipe implements PipeTransform {

  transform(file: File, PDFMatching: IPDFMatching[] ): number[] {
     return this.getItems(file?.name ?? '', 'category_ids', PDFMatching) as number[];
  }

}
